import ReactPlayer from 'react-player';
import Slider from 'react-slick';
import { useRef } from 'react';
import '../styles/system.scss';

const System = () => {

    let sliderRef = useRef(null);
    const next = () => {
        sliderRef.slickNext();
    };
    const previous = () => {
        sliderRef.slickPrev();
    };

    let sliderRef2 = useRef(null);
    const next2 = () => {
        sliderRef2.slickNext();
    };
    const previous2 = () => {
        sliderRef2.slickPrev();
    };

    let sliderRef3 = useRef(null);
    const next3 = () => {
        sliderRef3.slickNext();
    };
    const previous3 = () => {
        sliderRef3.slickPrev();
    };

    let sliderRef4 = useRef(null);
    const next4 = () => {
        sliderRef4.slickNext();
    };
    const previous4 = () => {
        sliderRef4.slickPrev();
    };

    let sliderRef5 = useRef(null);
    const next5 = () => {
        sliderRef5.slickNext();
    };
    const previous5 = () => {
        sliderRef5.slickPrev();
    };

    
    const settings = {
        className: "center",
        autoplay: true,
        infinite: true,
        speed: 1000,
        slidesToShow: 1,
        dots: true,
        appendDots: dots => (
            <div className="custom-slider_nav"style={{ textAlign: "center" }}>
                <button className="custom-slider_button custom-slider_prev" onClick={previous}>
                    <img src={`${process.env.PUBLIC_URL}/img/ui/prev.png`} alt="" />
                </button>
                <div className="custom-slider_dots">
                    {dots}
                </div>
                <button className="custom-slider_button custom-slider_next" onClick={next}>
                    <img src={`${process.env.PUBLIC_URL}/img/ui/next.png`} alt="" />
                </button>
            </div>
        ),
        customPaging: i => (
            <button className={`custom-slider_pagination`}>
                    
            </button>
        )
    };

    const settings2 = {
        className: "center",
        autoplay: true,
        infinite: true,
        speed: 1000,
        slidesToShow: 1,
        dots: true,
        appendDots: dots => (
            <div className="custom-slider_nav"style={{ textAlign: "center" }}>
                <button className="custom-slider_button custom-slider_prev" onClick={previous2}>
                    <img src={`${process.env.PUBLIC_URL}/img/ui/prev.png`} alt="" />
                </button>
                <div className="custom-slider_dots">
                    {dots}
                </div>
                <button className="custom-slider_button custom-slider_next" onClick={next2}>
                    <img src={`${process.env.PUBLIC_URL}/img/ui/next.png`} alt="" />
                </button>
            </div>
        ),
        customPaging: i => (
            <button className={`custom-slider_pagination`}>
                    
            </button>
        )
    };

    const settings3 = {
        className: "center",
        autoplay: true,
        infinite: true,
        speed: 1000,
        slidesToShow: 1,
        dots: true,
        appendDots: dots => (
            <div className="custom-slider_nav"style={{ textAlign: "center" }}>
                <button className="custom-slider_button custom-slider_prev" onClick={previous3}>
                    <img src={`${process.env.PUBLIC_URL}/img/ui/prev.png`} alt="" />
                </button>
                <div className="custom-slider_dots">
                    {dots}
                </div>
                <button className="custom-slider_button custom-slider_next" onClick={next3}>
                    <img src={`${process.env.PUBLIC_URL}/img/ui/next.png`} alt="" />
                </button>
            </div>
        ),
        customPaging: i => (
            <button className={`custom-slider_pagination`}>
                    
            </button>
        )
    };

     const settings4 = {
        className: "center",
        autoplay: true,
        infinite: true,
        speed: 1000,
        slidesToShow: 1,
        dots: true,
        appendDots: dots => (
            <div className="custom-slider_nav"style={{ textAlign: "center" }}>
                <button className="custom-slider_button custom-slider_prev" onClick={previous4}>
                    <img src={`${process.env.PUBLIC_URL}/img/ui/prev.png`} alt="" />
                </button>
                <div className="custom-slider_dots">
                    {dots}
                </div>
                <button className="custom-slider_button custom-slider_next" onClick={next4}>
                    <img src={`${process.env.PUBLIC_URL}/img/ui/next.png`} alt="" />
                </button>
            </div>
        ),
        customPaging: i => (
            <button className={`custom-slider_pagination`}>
                    
            </button>
        )
    };

     const settings5 = {
        className: "center",
        autoplay: true,
        infinite: true,
        speed: 1000,
        slidesToShow: 1,
        dots: true,
        appendDots: dots => (
            <div className="custom-slider_nav"style={{ textAlign: "center" }}>
                <button className="custom-slider_button custom-slider_prev" onClick={previous5}>
                    <img src={`${process.env.PUBLIC_URL}/img/ui/prev.png`} alt="" />
                </button>
                <div className="custom-slider_dots">
                    {dots}
                </div>
                <button className="custom-slider_button custom-slider_next" onClick={next5}>
                    <img src={`${process.env.PUBLIC_URL}/img/ui/next.png`} alt="" />
                </button>
            </div>
        ),
        customPaging: i => (
            <button className={`custom-slider_pagination`}>
                    
            </button>
        )
    };

    return (
        <div className='page-container main-bg system-page' >
            <img src={`${process.env.PUBLIC_URL}/img/footer/rp.svg`} alt='esrb rating' className='system-rating'/>
            <div className="title-wrapper" style={{marginTop: '100px'}}>
                <div className="title-character">
                    <img src={`${process.env.PUBLIC_URL}/img/ttl_chara04.png`} alt="" />
                </div>
                <img src={`${process.env.PUBLIC_URL}/img/ttl_system.png`} alt="" className="image-title" />
            </div>
            <div className="top-system_visual">
                <img src={`${process.env.PUBLIC_URL}/img/top-system_etrange.png`} alt="" className="top-system_etrange" />
                <div className="top-system_text body-text">
                    <p
                        style={{maxWidth: '600px'}}
                    >
                        Embark on a thrilling action adventure and rise to power alongside Étrange—a villainess cast into hell.
                    </p>
                    <span className="gold-block">
                        Recruit allies and bring enemies
                    </span> <br/>
                    <span className="magenta-block">
                        to heel in your conquest of hell!
                    </span>
                </div>
            </div>
            <div className="frame"
                style={{marginTop: '0px'}}
            >
                <img src={`${process.env.PUBLIC_URL}/img/deco_c1.png`} alt="Ribbon" className="ribbon" />
                <h4 className="system-subtitle">
                    Master the revolving lane mechanic to master combat!
                </h4>
                <h2 className="system-title">
                    Stages with Unique Mechanics!
                </h2>
                <img src={`${process.env.PUBLIC_URL}/img/ui/system_line.png`} alt="Decoraton Line" className="system-decoline" />
                <p className="system-text">
                    Lanes circle 'round and 'round in the combat zones, carrying helpful items with them. Depending on the stage, they can bring you bombs, turrets, gravity devices, and more!
                </p>
                <div className="system-pair">
                    <div className="left system-video">
                        <ReactPlayer
                            className='react-player'
                            src={`${process.env.PUBLIC_URL}/img/video/nore.mp4`}
                            autoPlay
                            muted
                            loop
                            width='100%'
                            height='100%'
                            onError={(error) => {
                                console.error('ReactPlayer error:', error)
                            }}
                        />
                    </div>
                    <div className="right card">
                        <div className="card-wrapper">
                            <h3 className="system-pair_title">
                                Ride!
                            </h3>
                            <h4 className="system-pair_caption">
                                Use lanes to deliver supplies faster than your enemies!
                            </h4>
                        </div>
                    </div>
                </div>
                <div className="system-pair reverse">
                    <div className="left card">
                        <div className="card-wrapper">
                            <h3 className="system-pair_title">
                                Assemble!
                            </h3>
                            <h4 className="system-pair_caption">
                                Wipe the floor with weaker enemies and protect your allies!
                            </h4>
                        </div>
                    </div>
                    <div className="right system-video">
                        <ReactPlayer
                            className='react-player'
                            src={`${process.env.PUBLIC_URL}/img/video/atsumero.mp4`}
                            autoPlay
                            muted
                            loop
                            width='100%'
                            height='100%'
                            onError={(error) => {
                                console.error('ReactPlayer error:', error)
                            }}
                        />
                    </div>
                </div>
                <div className="system-pair">
                    <div className="left system-video">
                            <ReactPlayer
                                className='react-player'
                                src={`${process.env.PUBLIC_URL}/img/video/nagero.mp4`}
                                autoPlay
                                muted
                                loop
                                width='100%'
                                height='100%'
                                onError={(error) => {
                                    console.error('ReactPlayer error:', error)
                                }}
                            />
                    </div>
                    <div className="right card">
                        <div className="card-wrapper">
                            <h3 className="system-pair_title">
                                Launch!
                            </h3>
                            <h4 className="system-pair_caption">
                                Operate catapults to defeat bosses!
                            </h4>
                        </div>
                    </div>
                </div>
            </div>
            <div className="system-sushi">
                <img src={`${process.env.PUBLIC_URL}/img/ttl_sushi.png`} alt="SUSHI" className="sushi-title" />
                <div className="pair ">
                    <div className="left">
                        <ReactPlayer
                            className='react-player'
                            src={`${process.env.PUBLIC_URL}/img/video/sushi_lane.mp4`}
                            autoPlay
                            muted
                            loop
                            width='100%'
                            height='100%'
                            onError={(error) => {
                                console.error('ReactPlayer error:', error)
                            }}
                            style={{ marginBottom: '15px' }}
                        />
                    </div>
                    <div className="right">
                        Lanes help players clear stages by converting the land's musical energy into support items. Take advantage of them to really lay the smackdown on your enemies and turn the tide of battle!
                    </div>
                    <div className="sushi_lane">
                        
                    </div>
                    <div className="sushi-track">
                        <div className="sushi_floaties">
                            <img src={`${process.env.PUBLIC_URL}/img/system/img_sushilane_item01.png`} alt="" />
                            <img src={`${process.env.PUBLIC_URL}/img/system/img_sushilane_item02.png`} alt="" />
                            <img src={`${process.env.PUBLIC_URL}/img/system/img_sushilane_item03.png`} alt="" />
                            <img src={`${process.env.PUBLIC_URL}/img/system/img_sushilane_item04.png`} alt="" />
                            <img src={`${process.env.PUBLIC_URL}/img/system/img_sushilane_item05.png`} alt="" />
                            <img src={`${process.env.PUBLIC_URL}/img/system/img_sushilane_item06.png`} alt="" />
                            <img src={`${process.env.PUBLIC_URL}/img/system/img_sushilane_item07.png`} alt="" />
                            <img src={`${process.env.PUBLIC_URL}/img/system/img_sushilane_item08.png`} alt="" />
                            <img src={`${process.env.PUBLIC_URL}/img/system/img_sushilane_item09.png`} alt="" />
                            <img src={`${process.env.PUBLIC_URL}/img/system/img_sushilane_item10.png`} alt="" />
                        </div>
                        <div className="sushi_floaties_2">
                            <img src={`${process.env.PUBLIC_URL}/img/system/img_sushilane_item01.png`} alt="" />
                            <img src={`${process.env.PUBLIC_URL}/img/system/img_sushilane_item02.png`} alt="" />
                            <img src={`${process.env.PUBLIC_URL}/img/system/img_sushilane_item03.png`} alt="" />
                            <img src={`${process.env.PUBLIC_URL}/img/system/img_sushilane_item04.png`} alt="" />
                            <img src={`${process.env.PUBLIC_URL}/img/system/img_sushilane_item05.png`} alt="" />
                            <img src={`${process.env.PUBLIC_URL}/img/system/img_sushilane_item06.png`} alt="" />
                            <img src={`${process.env.PUBLIC_URL}/img/system/img_sushilane_item07.png`} alt="" />
                            <img src={`${process.env.PUBLIC_URL}/img/system/img_sushilane_item08.png`} alt="" />
                            <img src={`${process.env.PUBLIC_URL}/img/system/img_sushilane_item09.png`} alt="" />
                            <img src={`${process.env.PUBLIC_URL}/img/system/img_sushilane_item10.png`} alt="" />
                        </div>
                    </div>
                </div>
            </div>
            <div className="frame">
                <img src={`${process.env.PUBLIC_URL}/img/deco_c2.png`} alt="Ribbon" className="ribbon" />
                <h4 className="system-subtitle">
                    Between lanes, cooking, and the sheer character variety, the possibilities are endless!
                </h4>
                <h2 className="system-title">
                    Customization and Tactics Galore!
                </h2>
                <img src={`${process.env.PUBLIC_URL}/img/ui/system_line.png`} alt="Decoraton Line" className="system-decoline" />
                <p className="system-text">
                    While character enhancement is a given, you can also customize lanes! Adjust them to your liking and employ whatever strategies you can think of!
                </p>
                <div className="slide-pair">
                    <div className="left">
                        <div className="slider-container screenshot-slider_container">
                            <Slider
                                ref={slider => {
                                    sliderRef = slider;
                                }}
                                {...settings}
                            >
                                <div className='screenshot-slider_wrapper'>
                                    <img src={`${process.env.PUBLIC_URL}/img/system/contents02/a00.webp`} alt="" className="slider-screenshot" />
                                </div>
                                <div className='screenshot-slider_wrapper'>
                                    <img src={`${process.env.PUBLIC_URL}/img/system/contents02/a01.png`} alt="" className="slider-screenshot" />
                                </div>
                                <div className='screenshot-slider_wrapper'>
                                    <img src={`${process.env.PUBLIC_URL}/img/system/contents02/a02.png`} alt="" className="slider-screenshot" />
                                </div>
                            </Slider>
                        </div>
                    </div>
                    <div className="right card">
                        <div className="slider-card">
                            <div className="slider-card_wrapper">
                                <h3 className="system-pair_title">
                                    Party Formation & Weapon Enhancement
                                </h3>
                                <h4 className="system-pair_caption">
                                    Choose from over ten playable characters, each with their own playstyle—from magic to dual swords to archery to martial arts!
                                    <br/><br/>
                                    Upgrade your allies and choose a party based on each individual stage—or your personal favorites!
                                </h4>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="slide-pair reverse-slide">
                    <div className="left card">
                        <div className="slider-card">
                            <div className="slider-card_wrapper">
                                <h3 className="system-pair_title">
                                    Cooking
                                </h3>
                                <h4 className="system-pair_caption">
                                    Cook a variety of dishes—from spicy foods to novelty sweets—at your base's cantina to receive combat buffs.
                                    <br/><br/>
                                    Keep your party well fed to conquer stages with ease!
                                </h4>
                            </div>
                        </div>
                    </div>
                    <div className="right">
                        <div className="slider-container screenshot-slider_container">
                            <Slider
                                ref={slider => {
                                    sliderRef2 = slider;
                                }}
                                {...settings2}
                            >
                                <div className='screenshot-slider_wrapper'>
                                    <img src={`${process.env.PUBLIC_URL}/img/system/contents02/b00.webp`} alt="" className="slider-screenshot" />
                                </div>
                                <div className='screenshot-slider_wrapper'>
                                    <img src={`${process.env.PUBLIC_URL}/img/system/contents02/b01.png`} alt="" className="slider-screenshot" />
                                </div>
                                <div className='screenshot-slider_wrapper'>
                                    <img src={`${process.env.PUBLIC_URL}/img/system/contents02/b02.png`} alt="" className="slider-screenshot" />
                                </div>
                            </Slider>
                        </div>
                    </div>
                </div>
                <div className="slide-pair">
                    <div className="left">
                        <div className="slider-container screenshot-slider_container">
                            <Slider
                                ref={slider => {
                                    sliderRef3 = slider;
                                }}
                                {...settings3}
                            >
                                <div className='screenshot-slider_wrapper'>
                                    <img src={`${process.env.PUBLIC_URL}/img/system/contents02/c00.webp`} alt="" className="slider-screenshot" />
                                </div>
                                <div className='screenshot-slider_wrapper'>
                                    <img src={`${process.env.PUBLIC_URL}/img/system/contents02/c01.png`} alt="" className="slider-screenshot" />
                                </div>
                                <div className='screenshot-slider_wrapper'>
                                    <img src={`${process.env.PUBLIC_URL}/img/system/contents02/c02.png`} alt="" className="slider-screenshot" />
                                </div>
                            </Slider>
                        </div>
                    </div>
                    <div className="right card">
                        <div className="slider-card">
                            <div className="slider-card_wrapper">
                                <h3 className="system-pair_title">
                                    Customizing Your Lanes
                                </h3>
                                <h4 className="system-pair_caption">
                                    Lanes deliver support items to the battlefield that boost attack power, recover HP, grant special attacks, etc.
                                    <br/><br/>
                                    Enhance your lanes with a wide range of perks that best suit your strategy!
                                </h4>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="frame">
                <img src={`${process.env.PUBLIC_URL}/img/deco_c3.png`} alt="Ribbon" className="ribbon" />
                <h4 className="system-subtitle">
                    Being a villainess is no easy task!
                </h4>
                <h2 className="system-title">
                    Conquer Hell as a Villainess
                </h2>
                <img src={`${process.env.PUBLIC_URL}/img/ui/system_line.png`} alt="Decoraton Line" className="system-decoline" />
                <p className="system-text">
                    Lead a wildly eccentric group of antiheroes—between villainesses, demons, cats, maids, mercenaries, and succubi—on raid after raid to seize your enemies' strongholds!
                </p>
                <img src={`${process.env.PUBLIC_URL}/img/system/versus.png`} alt="Versus" className="versus" />
                <img src={`${process.env.PUBLIC_URL}/img/system/versus_sp.png`} alt="Versus" className="versus-mobile" />
                <ReactPlayer
                    className='react-player'
                    src={`${process.env.PUBLIC_URL}/img/video/simulation.mp4`}
                    autoPlay
                    muted
                    loop
                    width='100%'
                    height='100%'
                    onError={(error) => {
                        console.error('ReactPlayer error:', error)
                    }}
                    style={{ marginBottom: '15px', maxWidth: '700px', margin: '50px 0px ' }}
                />
                <h2 className="system-pair_title">
                    Victory Is Only the Start!
                </h2>
                <p className="system-text" style={{maxWidth: '600px'}}>
                    Any first-rate villainess worth her salt knows she must tend to the territories she's captured. Enjoy the ultimate in simulated villainy by dispatching your allies on missions and having them steal items for you along the way.
                </p>
                <div className="pair-special">
                    <div className="left">
                        <h2 className="pair-special_title">
                            <img src={`${process.env.PUBLIC_URL}/img/ui/star.png`} alt="Star" className="star-accent" />
                            Dispatch Assignments
                            <img src={`${process.env.PUBLIC_URL}/img/ui/star.png`} alt="Star" className="star-accent" />
                        </h2>
                        <Slider
                            ref={slider => {
                                sliderRef4 =    slider;
                            }}
                            {...settings4}
                        >
                            <div className='screenshot-slider_wrapper'>
                                <img src={`${process.env.PUBLIC_URL}/img/system/contents03/a00.png`} alt="" className="slider-screenshot" />
                            </div>
                            <div className='screenshot-slider_wrapper'>
                                <img src={`${process.env.PUBLIC_URL}/img/system/contents03/a01.png`} alt="" className="slider-screenshot" />
                            </div>
                            <div className='screenshot-slider_wrapper'>
                                <img src={`${process.env.PUBLIC_URL}/img/system/contents03/a02.png`} alt="" className="slider-screenshot" />
                            </div>
                        </Slider>
                        <p className="system-text">
                            By dispatching your allies to locations that Étrange's army has sezied to invade, you can steal items and other materials not found in shops. 
                        </p>
                    </div>
                    <div className="right">
                        <h2 className="pair-special_title">
                            <img src={`${process.env.PUBLIC_URL}/img/ui/star.png`} alt="Star" className="star-accent" />
                            Enemy Revolts
                            <img src={`${process.env.PUBLIC_URL}/img/ui/star.png`} alt="Star" className="star-accent" />
                        </h2>
                        <Slider
                            ref={slider => {
                                sliderRef5 =    slider;
                            }}
                            {...settings5}
                        >
                            <div className='screenshot-slider_wrapper'>
                                <img src={`${process.env.PUBLIC_URL}/img/system/contents03/b00.png`} alt="" className="slider-screenshot" />
                            </div>
                            <div className='screenshot-slider_wrapper'>
                                <img src={`${process.env.PUBLIC_URL}/img/system/contents03/b01.png`} alt="" className="slider-screenshot" />
                            </div>
                            <div className='screenshot-slider_wrapper'>
                                <img src={`${process.env.PUBLIC_URL}/img/system/contents03/b02.png`} alt="" className="slider-screenshot" />
                            </div>
                        </Slider>
                        <p className="system-text">
                            If you progress through the story without heeding the demons' dissatisfaction in conquered areas, they will rise up and revolt. Will you quell the rebellion yourself, or send your comrades to deal with it? Keeping the peace in hell is your responsibility. 
                        </p>
                    </div>
                </div>
            </div>
            <div className="frame"
                style={{paddingBottom: '0px'}}
            >
                <img src={`${process.env.PUBLIC_URL}/img/deco_c4.png`} alt="Ribbon" className="ribbon" />
                <h4 className="system-subtitle">
                    Why do I sing? Because I want to, that's why!
                </h4>
                <div className="accent-wrapper">
                    <div className="left">
                        <img src={`${process.env.PUBLIC_URL}/img/system/musical-1.png`} alt="" className="musical-accent" />
                    </div>
                    <div className="content">
                        <h2 className="system-title">
                            Sing Your Heart Out in This <br/>Action-Packed Musical Adventure!
                        </h2>
                        <img src={`${process.env.PUBLIC_URL}/img/ui/system_line.png`} alt="Decoraton Line" className="system-decoline" />
                        <p className="system-text">
                            Fully-voiced cutscenes and musical performances make an already unconventional story even more exciting. Join Étrange's army and sing along!
                        </p>
                    </div>
                    <div className="right">
                        <img src={`${process.env.PUBLIC_URL}/img/system/musical-2.png`} alt="" className="musical-accent" />
                    </div>
                </div>
                <div className="accent-mobile">
                    <img src={`${process.env.PUBLIC_URL}/img/system/musical-1.png`} alt="" className="musical-accent" />
                </div>
                <div className="video-container">
                    <div className="video-wrapper">
                    <ReactPlayer
                        className='react-player'
                        src={`${process.env.PUBLIC_URL}/img/video/musical.mp4`}
                        loop
                        controls
                        width='100%'
                        height='100%'
                        onError={(error) => {
                            console.error('ReactPlayer error:', error)
                        }}
                        style={{ marginBottom: '15px' }}
                    />
                    </div>
                </div>
                
            </div>
            <div className="frame">
                <img src={`${process.env.PUBLIC_URL}/img/deco_c5.png`} alt="Ribbon" className="ribbon" />
                <div className="accent-wrapper" style={{marginBottom: '0px'}}>
                    <div className="left">
                        <img src={`${process.env.PUBLIC_URL}/img/system/multiplayer-1.png`} alt="" className="multiplayer-accent" />
                    </div>
                    <div className="content">
                        <h4 className="system-subtitle">
                            Troublemakers of the world <br/>unite online and across platforms!
                        </h4>
                        <h2 className="system-title">
                            Four-Player Online <br/> Multiplayer Stages!
                        </h2>
                    </div>
                    <div className="right">
                        <img src={`${process.env.PUBLIC_URL}/img/system/multiplayer-2.png`} alt="" className="multiplayer-accent" />
                    </div>
                </div>
                <img src={`${process.env.PUBLIC_URL}/img/ui/system_line.png`} alt="Decoraton Line" className="system-decoline" />
                <p className="system-text"
                    style={{marginBottom: '50px'}}
                >
                    Advance the story to unlock multiplayer stages, allowing for up to four-player simultaneous co-op. Team up online or via local couch co-op to tackle challenges even more chaotic than those found in the main story! 
                </p>
                <div className="accent-mobile">
                    <img src={`${process.env.PUBLIC_URL}/img/system/multiplayer-1.png`} alt="" className="mutiplayer-accent" />
                    <img src={`${process.env.PUBLIC_URL}/img/system/multiplayer-2.png`} alt="" className="mutiplayer-accent" />
                </div>
                <ReactPlayer
                    className='react-player'
                    src={`${process.env.PUBLIC_URL}/img/video/multiplayer.mp4`}
                    autoPlay
                    muted
                    loop
                    width='100%'
                    height='100%'
                    onError={(error) => {
                        console.error('ReactPlayer error:', error)
                    }}
                    style={{ marginBottom: '15px' }}
                />
            </div>
            <div className="bg-video">
                <div className="pattern">

                </div>
                <ReactPlayer
                    className='react-player'
                    src={`${process.env.PUBLIC_URL}/img/video/battle.mp4`}
                    autoPlay
                    muted
                    loop
                    width='100%'
                    height='100%'
                    onError={(error) => {
                        console.error('ReactPlayer error:', error)
                    }}
                    style={{ marginBottom: '15px' }}
                />
            </div>
        </div>
    )
}

export default System;
